export const RESET = 'MARKERS_LIST_RESET';
export const SET_ITEMS = 'MARKERS_LIST_SET_ITEMS';
export const SET_ERROR = 'MARKERS_LIST_SET_ERROR';
export const SET_MESSAGE = 'MARKERS_LIST_SET_MESSAGE';
export const TOGGLE_LOADING = 'MARKERS_LIST_TOGGLE_LOADING';
export const SET_LOADING = 'MARKERS_LIST_SET_LOADING';
export const ADD_MARKER = 'MARKERS_LIST_ADD_MARKER';
export const UPDATE_MARKER = 'MARKERS_LIST_UPDATE_MARKER';
export const DELETE_MARKER = 'MARKERS_LIST_DELETE_MARKER';
